<!--  -->
<template>

    <page pageDataUrl="/api/pageData/search" v-on:paddingData="paddingPageData" :params="{s:  this.$route.query.s }"
        :hasbreadcrumbs="true" :defPageTitle='title' ref="page">

        <div class='content'>
            <h1 class="entry-title">{{title}}</h1>
            <div v-if="results !== undefined &&  results.length>0">

                <div class="searchContentWrap" v-for="(item, index) in currentList" :key="index">
                    <div>
                        <router-link :to="{path:item.url}">
                            <h1 class="itemTitle">
                                {{item.title}}
                            </h1>
                        </router-link>
                    </div>
                    <div class="searchItemContent">
                        <p>{{item.content}}...<router-link :to="{path:item.url}">详情</router-link>
                        </p>
                    </div>
                </div>
                <div style="margin-top:50px;    text-align: center;">
                    <el-pagination layout="prev, pager, next" :total="results.length" @current-change="currentChange">
                    </el-pagination>
                </div>
            </div>
            <div v-if="results === undefined || results.length <= 0" class="no-data">
                什么也没找到，请用别的关键字试一试。
                <div class="search-wrap">
                    <el-input placeholder="请输入搜索内容" class="search-input" v-model="search_str" clearable>
                    </el-input>
                    <a @click="reload" style="height:30px;line-height:30px;margin-left: 10px;">
                        <i class="el-icon-search" style="color: orange;font-weight: 900;font-size: 18px;"></i>
                    </a>
                </div>
            </div>
        </div>
    </page>
</template>

<script>
    //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
    //例如：import 《组件名称》 from '《组件路径》';

    export default {
        //import引入的组件需要注入到对象中才能使用
        components: {},
        data() {
            //这里存放数据
            return {
                search_str: '',
                title: '',
                results: [],
                currentList: []
            };
        },
        //监听属性 类似于data概念
        computed: {},
        //监控data中的数据变化
        watch: {},
        //方法集合
        methods: {
            currentChange(val) {
                var start = (val - 1) * 10;
                var end = val * 10;
                if (end > this.results.length)
                    end = this.results.length
                this.currentList = this.results.slice(start, end)
            },
            reload() {
                this.title = "【" + this.search_str + "】的搜索结果"
                this.$refs.page.reload({ s: this.search_str }, this.title)
            },
            paddingPageData(data) {
                this.results = data.data
                this.currentChange(1)
            },
        },
        //生命周期 - 创建完成（可以访问当前this实例）
        created() {
            this.title = "【" + this.$route.query.s + "】的搜索结果"
        },
        //生命周期 - 挂载完成（可以访问DOM元素）
        mounted() {
        },
        beforeCreate() { }, //生命周期 - 创建之前
        beforeMount() { }, //生命周期 - 挂载之前
        beforeUpdate() { }, //生命周期 - 更新之前
        updated() { }, //生命周期 - 更新之后
        beforeDestroy() { }, //生命周期 - 销毁之前
        destroyed() { }, //生命周期 - 销毁完成
        activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style>
    .itemTitle {
        font-size: 105%;
        color: #314478;
        line-height: 1.3;
        padding: 0 0 10px 0;
        text-align: left;
        font-weight: bold;
        text-indent: -1.1em;
        padding-left: 1.1em;
    }

    .no-data {
        text-align: center;
        min-width: 980px;

    }

    .search-wrap {}

    .search-input {
        margin-top: 50px;
        height: 30px !important;
        line-height: 30px !important;
        width: 180px !important;
    }

    .search-input .el-input__inner {
        line-height: 30px !important;
        height: 30px !important;
    }

    .searchContentWrap {
        width: 100%;
    }

    .searchItemContent {
        padding-left: 5px;
        margin-bottom: 30px;
    }

    .searchItemContent p,
    a {
        font-size: 96%;
    }

    .searchItemContent a {
        color: #0066CB;
        box-shadow: 0 1px 0 0 currentColor;
        cursor: pointer;
        margin-left: 5px;
    }
</style>